import { render, staticRenderFns } from "./arcaea.vue?vue&type=template&id=5a0e1268&"
import script from "./arcaea.vue?vue&type=script&lang=tsx&"
export * from "./arcaea.vue?vue&type=script&lang=tsx&"
import style0 from "./arcaea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports